module.exports = __webpack_public_path__ + "img/comment.d2e1b0b4.svg";